import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { BracelitPreloaderModule } from '@bee-components/common/bracelit-preloader';

import { MaterialModule } from '../../angular-material/material.module';
import { VoucherDetailsComponent } from './';
import { TicketHolderDataComponent } from './ticket-holder-data/ticket-holder-data.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        BracelitPreloaderModule
    ],
    declarations: [
        VoucherDetailsComponent,
        TicketHolderDataComponent
    ],
    exports: [
        VoucherDetailsComponent,
        TicketHolderDataComponent
    ],
    providers: []
})
export class BracelitEntryComponentsModule {
}
